import domain from './domain';

// Reset team connections
export const resetTeamConnections = domain.createEvent('resetTeamConnections');
